import { useState, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { Bath, BedDouble, Users } from 'lucide-react'
import PublishAlert from '../components/common/PublishAlert'

const GROUPS = [
{
title:'Ambientes',
groupKey:'ambientes',
items:[
{label:'Living',key:'living'},
{label:'Living comedor',key:'living_comedor'},
{label:'Cocina',key:'cocina'},
{label:'Comedor',key:'comedor'},
{label:'Estudio / Oficina',key:'estudio'},
{label:'Lavadero',key:'lavadero'},
{label:'Despensa',key:'despensa'},
{label:'Sala de juegos',key:'sala_juegos'},
{label:'Dependencia de servicio',key:'dependencia_servicio'},
{label:'Vestidor',key:'vestidor'},
{label:'Dormitorio en suite',key:'dormitorio_suite'}
]

},
{
title:'Exteriores',
groupKey:'exteriores',
items:[
{label:'Jardín',key:'jardin'},
{label:'Patio',key:'patio'},
{label:'Terraza',key:'terraza'},
{label:'Balcón',key:'balcon'},
{label:'Quincho',key:'quincho'},
{label:'Galería cubierta',key:'galeria_cubierta'},
{label:'Parrilla / Churrasquera',key:'parrilla'},
{label:'Pileta',key:'piscina'}
]

},
{
title:'Comodidades',
groupKey:'comodidades',
items:[
{label:'Cochera',key:'cochera'},
{label:'Cochera para 2+ autos',key:'cochera_doble'},
{label:'Baulera',key:'baulera'},
{label:'Aire acondicionado',key:'aire_acondicionado'},
{label:'Calefacción',key:'calefaccion'},
{label:'Losa radiante',key:'losa_radiante'},
{label:'Seguridad 24 h',key:'seguridad'},
{label:'Portón automático',key:'porton_automatico'},
{label:'Riego por aspersión',key:'riego_aspersion'},
{label:'Paneles solares',key:'paneles_solares'},
{label:'Pileta climatizada',key:'pileta_climatizada'},
{label:'Quincho cerrado equipado',key:'quincho_cerrado'},
{label:'Gimnasio',key:'gimnasio'},
{label:'Sauna',key:'sauna'},
{label:'Cava',key:'cava'},
{label:'Apto mascotas',key:'apto_mascotas'}
]
},
{
title:'Extras destacados',
groupKey:'extras',
items:[
{label:'Vista a la montaña',key:'vista_montana'},
{label:'Vista abierta',key:'vista_abierta'},
{label:'Vista al agua / río / dique',key:'vista_agua'},
{label:'Vista a viñedos',key:'vista_vinedos'},
{label:'Barrio privado',key:'barrio_privado'},
{label:'A estrenar',key:'a_estrenar'},
{label:'Amoblada',key:'amoblada'}
]
}
]

const VACATION_OPTIONS={
services:[
{label:'Wi-Fi',key:'wifi'},{label:'Ropa de cama',key:'ropa_cama'},{label:'Toallas',key:'toallas'},
{label:'Cocina equipada',key:'cocina_equipada'},{label:'Estacionamiento',key:'estacionamiento'},
{label:'Desayuno',key:'desayuno'},{label:'Limpieza incluida',key:'limpieza'},{label:'Recepción 24 h',key:'recepcion_24h'},
{label:'Estufa a leña',key:'estufa_lena'},{label:'Chimenea',key:'chimenea'},{label:'Aire acondicionado',key:'aire_acondicionado'},{label:'Calefacción',key:'calefaccion'},
{label:'Pileta',key:'pileta'},{label:'Churrasquera / parrilla',key:'churrasquera'},{label:'Jardín',key:'jardin'},{label:'Terraza',key:'terraza'},
{label:'Juegos de mesa',key:'juegos_mesa'},{label:'Mesa de ping pong',key:'ping_pong'},{label:'TV / streaming',key:'tv_streaming'},{label:'Lavadora',key:'lavadora'},{label:'Mascotas bienvenidas',key:'mascotas'}
],
experiences:[
{label:'Escapada romántica',key:'romantica'},{label:'Ideal para familias',key:'familias'},
{label:'Aventura y montaña',key:'aventura'},{label:'Vino y gastronomía',key:'vino_gastronomia'},
{label:'Relax y bienestar',key:'bienestar'},{label:'Trabajo remoto',key:'trabajo_remoto'}
],
nearby:[
{label:'Bodegas',key:'bodegas'},{label:'Montaña',key:'montana'},{label:'Centro urbano',key:'centro'},
{label:'Termas / spa',key:'termas'},{label:'Ríos o diques',key:'rios_diques'},{label:'Nieve / esquí',key:'nieve'},
{label:'Gastronomía',key:'gastronomia'},{label:'Senderos',key:'senderos'}
]
}

const BED_TYPES=[
{key:'single',label:'Cama individual',places:1},
{key:'double',label:'Cama doble',places:2},
{key:'bunk',label:'Cucheta',places:2},
{key:'sofaSingle',label:'Sofá cama individual',places:1},
{key:'sofaDouble',label:'Sofá cama doble',places:2}
]

const RENTAL_OPTIONS={
guarantees:[{label:'Recibo de sueldo',key:'recibo_sueldo'},{label:'Garantía propietaria',key:'garantia_propietaria'},{label:'Seguro de caución',key:'seguro_caucion'},{label:'Garante',key:'garante'}],
included:[{label:'Agua',key:'agua'},{label:'Internet',key:'internet'},{label:'Municipalidad',key:'municipalidad'},{label:'Expensas',key:'expensas'}]
}

const VISIBLE_FEATURES={
venta:{ambientes:null,exteriores:null,comodidades:['cochera','cochera_doble','baulera','aire_acondicionado','calefaccion','losa_radiante','seguridad','porton_automatico','riego_aspersion','paneles_solares','pileta_climatizada','quincho_cerrado','gimnasio','sauna','cava','apto_mascotas'],extras:['vista_montana','vista_abierta','vista_agua','vista_vinedos','barrio_privado','a_estrenar']},
alquiler:{ambientes:null,exteriores:null,comodidades:['cochera','cochera_doble','baulera','aire_acondicionado','calefaccion','losa_radiante','seguridad','porton_automatico','riego_aspersion','paneles_solares','pileta_climatizada','quincho_cerrado','gimnasio','sauna','cava','apto_mascotas'],extras:['vista_montana','vista_abierta','vista_agua','vista_vinedos','barrio_privado','amoblada']},
alquiler_temporal:{ambientes:null,exteriores:null,comodidades:['amoblado','aire_acondicionado','calefaccion','seguridad','apto_mascotas'],extras:['vista_montana','vista_abierta','vista_agua','vista_vinedos','amoblada']},
alquiler_vacacional:{ambientes:['living','living_comedor','cocina','comedor','estudio','sala_juegos'],exteriores:null,comodidades:['aire_acondicionado','calefaccion','seguridad','apto_mascotas'],extras:['vista_montana','vista_abierta']}
}

export default function NewPropertyPro({onBack,onSubmit,initialData={}}){

const [isMobile,setIsMobile]=useState(()=>typeof window!=='undefined'&&window.matchMedia('(max-width: 900px)').matches)
const [vacationStep,setVacationStep]=useState(0)
const [propertyStep,setPropertyStep]=useState(0)
const [exitConfirmOpen,setExitConfirmOpen]=useState(false)
const [publishNotice,setPublishNotice]=useState('')

useEffect(()=>{
  const media=window.matchMedia('(max-width: 900px)')
  const update=()=>setIsMobile(media.matches)
  update();media.addEventListener('change',update)
  return()=>media.removeEventListener('change',update)
},[])

const [features,setFeatures]=useState({
ambientes:[],
exteriores:[],
comodidades:['apto_mascotas'],
extras:[],
metrosCubiertos:'',
metrosTotales:'',
dormitorios:1,
banos:1
})

const [extra,setExtra]=useState({
expenses:'',
isAptoCredito:false,
age:'',
orientation:'',
condition:''
})
const isVacation=initialData.operation==='alquiler_vacacional'
const isRental=['alquiler','alquiler_temporal'].includes(initialData.operation)
const isSale=initialData.operation==='venta'
const isLand=['lote','finca','campo','vinedo'].includes(initialData.type)
const [vacation,setVacation]=useState({maximumGuests:2,minimumNights:1,beds:1,bedTypes:{single:0,double:1,bunk:0,sofaSingle:0,sofaDouble:0},petsAllowed:true,checkIn:'15:00',checkOut:'10:00',cancellationPolicy:'flexible',services:[],experiences:[],nearby:[],nearbyNotes:'',houseRules:'',unavailableRanges:[],blockedFrom:'',blockedTo:''})
const [capacityError,setCapacityError]=useState('')
const [rental,setRental]=useState({contractMonths:24,depositMonths:1,furnished:false,guarantees:[],guarantorsCount:1,includedServices:[],requirements:''})
const [contact,setContact]=useState({whatsapp:initialData.contactPreferences?.whatsapp || false,phone:initialData.contactPreferences?.phone || ''})

/* ===============================
   CARGAR DATOS SI EDITAMOS
   =============================== */

useEffect(()=>{

if(!initialData || Object.keys(initialData).length === 0) return

setFeatures({
ambientes:initialData.features?.ambientes || [],
exteriores:initialData.features?.exteriores || [],
comodidades:initialData.features?.comodidades?.length
  ? initialData.features.comodidades
  : initialData.petsAllowed === false ? [] : ['apto_mascotas'],
extras:initialData.features?.extras || [],
metrosCubiertos:initialData.surfaceCovered || '',
metrosTotales:initialData.surfaceTotal || '',
dormitorios:initialData.bedrooms || initialData.vacation?.bedrooms || 1,
banos:initialData.bathrooms || 1
})

setExtra({
expenses:initialData.expenses || '',
isAptoCredito:initialData.isAptoCredito || false,
age:initialData.age || '',
orientation:initialData.orientation || '',
condition:initialData.condition || ''
})
setVacation({
maximumGuests:initialData.vacation?.maximumGuests || 2,
minimumNights:initialData.vacation?.minimumNights || 1,
checkIn:initialData.vacation?.checkIn || '15:00',
checkOut:initialData.vacation?.checkOut || '10:00',
cancellationPolicy:initialData.vacation?.cancellationPolicy || 'flexible'
,
services:initialData.vacation?.services || [],
experiences:initialData.vacation?.experiences || [],
nearby:initialData.vacation?.nearby || [],
nearbyNotes:initialData.vacation?.nearbyNotes || '',
houseRules:initialData.vacation?.houseRules || ''
,
beds:initialData.vacation?.beds || 1,
bedTypes:initialData.vacation?.bedTypes && Object.values(initialData.vacation.bedTypes).some(Number)
  ? initialData.vacation.bedTypes
  : {single:initialData.vacation?.beds || 0,double:0,bunk:0,sofaSingle:0,sofaDouble:0},
petsAllowed:initialData.petsAllowed !== false && initialData.vacation?.petsAllowed !== false,
unavailableRanges:(initialData.vacation?.unavailableRanges || []).map(range=>({
  from:range.from?.slice?.(0,10) || '',
  to:range.to?.slice?.(0,10) || ''
})).filter(range=>range.from&&range.to),
blockedFrom:'',
blockedTo:''
})
setRental({contractMonths:initialData.rental?.contractMonths || 24,depositMonths:initialData.rental?.depositMonths || 1,furnished:initialData.rental?.furnished || false,guarantees:initialData.rental?.guarantees || [],guarantorsCount:initialData.rental?.guarantorsCount || 1,includedServices:initialData.rental?.includedServices || [],requirements:initialData.rental?.requirements || ''})

},[initialData])

const toggleFeature=(groupKey,itemKey)=>{
setFeatures(prev=>{
const exists=prev[groupKey].includes(itemKey)
return{
...prev,
[groupKey]:exists
?prev[groupKey].filter(k=>k!==itemKey)
:[...prev[groupKey],itemKey]
}
})
}

const updateField=(key,value)=>{
setFeatures(prev=>({...prev,[key]:value}))
}

const updateExtra=(key,value)=>{
setExtra(prev=>({...prev,[key]:value}))
}
const updateVacation=(key,value)=>setVacation(prev=>({...prev,[key]:value}))
const toggleVacation=(group,key)=>setVacation(prev=>({...prev,[group]:prev[group].includes(key)?prev[group].filter(item=>item!==key):[...prev[group],key]}))
const addUnavailableRange=()=>{
  if(!vacation.blockedFrom||!vacation.blockedTo||vacation.blockedTo<=vacation.blockedFrom)return
  setVacation(prev=>({
    ...prev,
    unavailableRanges:[...prev.unavailableRanges,{from:prev.blockedFrom,to:prev.blockedTo}]
      .sort((a,b)=>a.from.localeCompare(b.from)),
    blockedFrom:'',
    blockedTo:''
  }))
}
const removeUnavailableRange=(index)=>setVacation(prev=>({
  ...prev,
  unavailableRanges:prev.unavailableRanges.filter((_,itemIndex)=>itemIndex!==index)
}))
const updateRental=(key,value)=>setRental(prev=>({...prev,[key]:value}))
const toggleRental=(group,key)=>setRental(prev=>({...prev,[group]:prev[group].includes(key)?prev[group].filter(item=>item!==key):[...prev[group],key]}))

const changeCounter=(key,delta)=>{
setFeatures(prev=>{
const next=Math.max(1,(prev[key]||1)+delta)
return {...prev,[key]:next}
})
}

const changeVacationCounter=(key,delta,min=1)=>{
setVacation(prev=>({
...prev,
[key]:Math.max(min,(Number(prev[key])||min)+delta)
}))
setCapacityError('')
}

const changeBedType=(key,delta)=>{
setVacation(prev=>({
...prev,
bedTypes:{...prev.bedTypes,[key]:Math.max(0,(Number(prev.bedTypes?.[key])||0)+delta)}
}))
setCapacityError('')
}

const totalBeds=BED_TYPES.reduce((total,item)=>total+(Number(vacation.bedTypes?.[item.key])||0),0)
const sleepingPlaces=BED_TYPES.reduce((total,item)=>total+(Number(vacation.bedTypes?.[item.key])||0)*item.places,0)

const handleSubmit=()=>{

if(!isVacation && (!Number(features.metrosCubiertos) || !Number(features.metrosTotales))){
  setPublishNotice('Indicá los metros cubiertos y los metros totales para continuar.')
  return
}

const rooms=Math.max(1,Number(features.dormitorios)||1)
const bathrooms=Math.max(1,Number(features.banos)||1)
const petsAllowed=features.comodidades.includes('apto_mascotas')
const vacationPayload={...vacation,petsAllowed}
delete vacationPayload.blockedFrom
delete vacationPayload.blockedTo
onSubmit({
rooms: isLand || isVacation ? 0 : rooms + 1,
bedrooms: isLand ? 0 : rooms,
bathrooms: isLand ? 0 : bathrooms,
surfaceCovered:Number(features.metrosCubiertos)||0,
surfaceTotal:Number(features.metrosTotales)||0,
petsAllowed,
features:{
ambientes:features.ambientes,
exteriores:features.exteriores,
comodidades:features.comodidades,
extras:features.extras
},
...(isSale ? {expenses:Number(extra.expenses)||0,isAptoCredito:extra.isAptoCredito,age:Number(extra.age)||0} : {}),
...(isRental ? {expenses:Number(extra.expenses)||0} : {}),
...(isSale && extra.orientation ? { orientation: extra.orientation } : {}),
...(isSale && extra.condition ? { condition: extra.condition } : {}),
...(isVacation ? { vacation:{
  ...vacationPayload,
  maximumGuests:Number(vacation.maximumGuests)||1,
  minimumNights:Number(vacation.minimumNights)||1,
  beds:Math.max(1,totalBeds),
  sleepingPlaces,
  bedTypes:vacation.bedTypes,
  bedrooms:rooms,
  unavailableRanges:vacation.unavailableRanges
} } : {}),
...(isRental ? { rental:{...rental,contractMonths:Number(rental.contractMonths)||1,depositMonths:Number(rental.depositMonths)||0,guarantorsCount:rental.guarantees.includes('garante') ? Math.max(1,Number(rental.guarantorsCount)||1) : 0} } : {})
,
contactPreferences:{whatsapp:contact.whatsapp,phone:contact.phone.trim()}
})
}

const requestExit=()=>setExitConfirmOpen(true)
const confirmExit=()=>{setExitConfirmOpen(false);onBack()}
const ExitConfirmation=()=>exitConfirmOpen&&<ExitBackdrop role="presentation"><ExitDialog role="dialog" aria-modal="true" aria-labelledby="exit-title"><span>PUBLICACIÓN EN CURSO</span><h2 id="exit-title">¿Querés salir de este paso?</h2><p>Los cambios que todavía no continuaste no se guardarán.</p><div><button type="button" onClick={()=>setExitConfirmOpen(false)}>Seguir editando</button><button type="button" onClick={confirmExit}>Salir sin guardar</button></div></ExitDialog></ExitBackdrop>

if(!isVacation&&isMobile){
  const totalSteps=isRental ? 3 : 2
  const nextPropertyStep=()=>{
    if(propertyStep===0&&(!Number(features.metrosCubiertos)||!Number(features.metrosTotales))){
      setPublishNotice('Indicá los metros cubiertos y los metros totales para continuar.')
      return
    }
    setPropertyStep(step=>Math.min(totalSteps-1,step+1))
  }
  const backPropertyStep=()=>propertyStep===0?onBack():setPropertyStep(step=>step-1)
  return <MobileQuizPage><MobileQuizCard><MobileQuizClose type="button" onClick={requestExit} aria-label="Cerrar publicación">×</MobileQuizClose>
    {propertyStep===0&&<><MobileQuizKicker>LA PROPIEDAD</MobileQuizKicker><h1>Contá lo esencial.</h1><p>Estos datos permiten entender rápidamente cómo se distribuye la propiedad.</p><MobileQuizFields><InputBox><label>Metros cubiertos</label><input type="number" value={features.metrosCubiertos} onChange={e=>updateField('metrosCubiertos',e.target.value)}/></InputBox><InputBox><label>Metros totales</label><input type="number" value={features.metrosTotales} onChange={e=>updateField('metrosTotales',e.target.value)}/></InputBox></MobileQuizFields>{!isLand&&<><MobileCounterList><MobileCounterItem><span><BedDouble/>Dormitorios</span><Counter><button type="button" onClick={()=>changeCounter('dormitorios',-1)}>−</button><b>{features.dormitorios}</b><button type="button" onClick={()=>changeCounter('dormitorios',1)}>+</button></Counter></MobileCounterItem><MobileCounterItem><span><Bath/>Baños</span><Counter><button type="button" onClick={()=>changeCounter('banos',-1)}>−</button><b>{features.banos}</b><button type="button" onClick={()=>changeCounter('banos',1)}>+</button></Counter></MobileCounterItem></MobileCounterList><MobileQuizChips>{GROUPS[0].items.map(item=><Chip key={item.key} active={features.ambientes.includes(item.key)} onClick={()=>toggleFeature('ambientes',item.key)}>{item.label}</Chip>)}</MobileQuizChips></>}<MobileQuizChips>{GROUPS[1].items.map(item=><Chip key={item.key} active={features.exteriores.includes(item.key)} onClick={()=>toggleFeature('exteriores',item.key)}>{item.label}</Chip>)}</MobileQuizChips></>}
    {propertyStep===1&&<><MobileQuizKicker>COMODIDADES Y EXTRAS</MobileQuizKicker><h1>¿Qué la hace especial?</h1><p>Marcá solo los atributos reales que agregan valor y ayudan a comparar.</p><MobileQuizChips>{GROUPS[2].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.comodidades || VISIBLE_FEATURES[initialData.operation].comodidades.includes(item.key)).map(item=><Chip key={item.key} active={features.comodidades.includes(item.key)} onClick={()=>toggleFeature('comodidades',item.key)}>{item.label}</Chip>)}</MobileQuizChips><MobileQuizChips>{GROUPS[3].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.extras || VISIBLE_FEATURES[initialData.operation].extras.includes(item.key)).map(item=><Chip key={item.key} active={features.extras.includes(item.key)} onClick={()=>toggleFeature('extras',item.key)}>{item.label}</Chip>)}</MobileQuizChips>{!isRental&&<ContactOptions><label><input type="checkbox" checked={contact.whatsapp} onChange={e=>setContact(prev=>({...prev,whatsapp:e.target.checked}))}/> Permitir consultas por WhatsApp</label>{contact.whatsapp&&<input type="tel" value={contact.phone} placeholder="Tu número de WhatsApp" onChange={e=>setContact(prev=>({...prev,phone:e.target.value}))}/>}</ContactOptions>}</>}
    {propertyStep===2&&<><MobileQuizKicker>CONDICIONES</MobileQuizKicker><h1>Dejá todo claro.</h1><p>Así las consultas llegan mejor orientadas.</p><MobileQuizFields><InputBox><label>Contrato mínimo</label><select value={rental.contractMonths} onChange={e=>updateRental('contractMonths',e.target.value)}><option value="6">6 meses</option><option value="12">12 meses</option><option value="24">24 meses</option><option value="36">36 meses</option></select></InputBox><InputBox><label>Meses de depósito</label><input type="number" min="0" max="6" value={rental.depositMonths} onChange={e=>updateRental('depositMonths',e.target.value)}/></InputBox><InputBox><label>Expensas mensuales</label><input type="number" value={extra.expenses} onChange={e=>updateExtra('expenses',e.target.value)}/></InputBox></MobileQuizFields><Checkbox><input type="checkbox" checked={rental.furnished} onChange={e=>updateRental('furnished',e.target.checked)}/><span>Se entrega amoblada</span></Checkbox><h3>Garantías aceptadas</h3><MobileQuizChips>{RENTAL_OPTIONS.guarantees.map(item=><Chip key={item.key} active={rental.guarantees.includes(item.key)} onClick={()=>toggleRental('guarantees',item.key)}>{item.label}</Chip>)}</MobileQuizChips>{rental.guarantees.includes('garante')&&<InputBox><label>¿Cuántos garantes pedís?</label><input type="number" min="1" max="6" value={rental.guarantorsCount} onChange={e=>updateRental('guarantorsCount',e.target.value)}/></InputBox>}<h3>Servicios incluidos</h3><MobileQuizChips>{RENTAL_OPTIONS.included.map(item=><Chip key={item.key} active={rental.includedServices.includes(item.key)} onClick={()=>toggleRental('includedServices',item.key)}>{item.label}</Chip>)}</MobileQuizChips><TextArea placeholder="Otros requisitos o condiciones importantes…" value={rental.requirements} onChange={e=>updateRental('requirements',e.target.value)}/></>}
  </MobileQuizCard><MobileQuizFooter><button type="button" onClick={backPropertyStep}>Atrás</button><button type="button" onClick={propertyStep===totalSteps-1?handleSubmit:nextPropertyStep}>{propertyStep===totalSteps-1?'Continuar':'Siguiente →'}</button></MobileQuizFooter><ExitConfirmation /><PublishAlert message={publishNotice} onClose={()=>setPublishNotice('')} /></MobileQuizPage>
}

if(isVacation&&isMobile){
  const totalSteps=5
  const continueQuiz=()=>{
    if(vacationStep===0&&sleepingPlaces<Number(vacation.maximumGuests)){
      setCapacityError(`Indicás hasta ${vacation.maximumGuests} huéspedes, pero sólo hay ${sleepingPlaces} plazas para dormir. Sumá camas antes de continuar.`)
      return
    }
    setCapacityError('')
    setVacationStep(step=>Math.min(totalSteps-1,step+1))
  }
  const backQuiz=()=>vacationStep===0?onBack():setVacationStep(step=>step-1)
  return <MobileQuizPage><MobileQuizCard><MobileQuizClose type="button" onClick={requestExit} aria-label="Cerrar publicación">×</MobileQuizClose>
      {vacationStep===0&&<><MobileQuizKicker>CAPACIDAD</MobileQuizKicker><h1>¿Para cuántas personas?</h1><p>Indicá la capacidad máxima y los espacios disponibles.</p><MobileCounterList><MobileCounterItem><span><Users/>Huéspedes</span><Counter><button type="button" onClick={()=>changeVacationCounter('maximumGuests',-1)}>−</button><b>{vacation.maximumGuests}</b><button type="button" onClick={()=>changeVacationCounter('maximumGuests',1)}>+</button></Counter></MobileCounterItem><MobileCounterItem><span><BedDouble/>Dormitorios</span><Counter><button type="button" onClick={()=>changeCounter('dormitorios',-1)}>−</button><b>{features.dormitorios}</b><button type="button" onClick={()=>changeCounter('dormitorios',1)}>+</button></Counter></MobileCounterItem><MobileCounterItem><span><BedDouble/>Camas dobles</span><Counter><button type="button" onClick={()=>changeBedType('double',-1)}>−</button><b>{vacation.bedTypes?.double||0}</b><button type="button" onClick={()=>changeBedType('double',1)}>+</button></Counter></MobileCounterItem><MobileCounterItem><span><Bath/>Baños</span><Counter><button type="button" onClick={()=>changeCounter('banos',-1)}>−</button><b>{features.banos}</b><button type="button" onClick={()=>changeCounter('banos',1)}>+</button></Counter></MobileCounterItem></MobileCounterList><MobileCapacityNote>{sleepingPlaces} plazas para dormir</MobileCapacityNote>{capacityError&&<CapacityError role="alert">{capacityError}</CapacityError>}</>}
      {vacationStep===1&&<><MobileQuizKicker>LA ESTADÍA</MobileQuizKicker><h1>Definí lo esencial.</h1><p>Estos datos ayudan a que la consulta llegue con expectativas claras.</p><MobileQuizFields><InputBox><label>Mínimo de noches</label><input type="number" min="1" value={vacation.minimumNights} onChange={e=>updateVacation('minimumNights',e.target.value)}/></InputBox><InputBox><label>Check-in desde</label><input type="time" value={vacation.checkIn} onChange={e=>updateVacation('checkIn',e.target.value)}/></InputBox><InputBox><label>Check-out hasta</label><input type="time" value={vacation.checkOut} onChange={e=>updateVacation('checkOut',e.target.value)}/></InputBox><InputBox><label>Cancelación</label><select value={vacation.cancellationPolicy} onChange={e=>updateVacation('cancellationPolicy',e.target.value)}><option value="flexible">Flexible</option><option value="moderada">Moderada</option><option value="estricta">Estricta</option></select></InputBox></MobileQuizFields></>}
      {vacationStep===2&&<><MobileQuizKicker>SERVICIOS</MobileQuizKicker><h1>¿Qué incluye la estadía?</h1><p>Elegí lo que el huésped encontrará al llegar.</p><MobileQuizChips>{VACATION_OPTIONS.services.map(item=><Chip key={item.key} active={vacation.services.includes(item.key)} onClick={()=>toggleVacation('services',item.key)}>{item.label}</Chip>)}</MobileQuizChips></>}
      {vacationStep===3&&<><MobileQuizKicker>EXPERIENCIA</MobileQuizKicker><h1>¿Qué hace especial al lugar?</h1><p>Elegí los planes que mejor lo representan.</p><MobileQuizChips>{VACATION_OPTIONS.experiences.map(item=><Chip key={item.key} active={vacation.experiences.includes(item.key)} onClick={()=>toggleVacation('experiences',item.key)}>{item.label}</Chip>)}</MobileQuizChips></>}
      {vacationStep===4&&<><MobileQuizKicker>REGLAS DE LA CASA</MobileQuizKicker><h1>Contá cómo cuidar el espacio.</h1><p>Es muy importante para que los huéspedes sepan qué esperar antes de consultarte. Sumá horarios, cuidados y lo que no está permitido.</p><RulesExamples><span>Ideas: no fumar · sin fiestas · horario de silencio · mascotas · uso de pileta o parrilla.</span></RulesExamples><TextArea placeholder="Ej.: No se permite fumar dentro. Silencio desde las 23 h. La pileta es de uso exclusivo de huéspedes registrados." value={vacation.houseRules} onChange={e=>updateVacation('houseRules',e.target.value)}/><ContactOptions><label><input type="checkbox" checked={contact.whatsapp} onChange={e=>setContact(prev=>({...prev,whatsapp:e.target.checked}))}/> Permitir consultas por WhatsApp</label>{contact.whatsapp&&<input type="tel" value={contact.phone} placeholder="Tu número de WhatsApp" onChange={e=>setContact(prev=>({...prev,phone:e.target.value}))}/>}</ContactOptions><RulesOptional>Podés dejar las reglas vacías y completarlas después.</RulesOptional></>}
    </MobileQuizCard>
    <MobileQuizFooter><button type="button" onClick={backQuiz}>Atrás</button><button type="button" onClick={vacationStep===totalSteps-1?handleSubmit:continueQuiz}>{vacationStep===totalSteps-1?'Continuar':'Siguiente →'}</button></MobileQuizFooter>
  <ExitConfirmation /></MobileQuizPage>
}

return(

<Page>

<PublishAlert message={publishNotice} onClose={()=>setPublishNotice('')} />

<Container>

<Header>
<h1>{isVacation?'Armá la experiencia':isRental?'Prepará el alquiler':'Presentá su verdadero valor'}</h1>
<p>{isVacation?'Definí cómo será la estadía y ayudá a tus huéspedes a imaginarse ahí.':isRental?'Contá cómo es vivir acá y dejá claras las condiciones desde el principio.':'Sumá los atributos que ayudan a una persona a tomar una decisión de compra.'}</p>
</Header>

{isVacation && <VacationCard>
<VacationIntro><span>CAPACIDAD DEL ALOJAMIENTO</span><h2>¿Quiénes pueden quedarse?</h2><p>Como en Booking: simple, concreto y fácil de comparar antes de consultar.</p></VacationIntro>
<CapacityGrid>
  <CapacityItem><span>Huéspedes</span><small>Capacidad máxima</small><Counter><button type="button" onClick={()=>changeVacationCounter('maximumGuests',-1)}>−</button><b>{vacation.maximumGuests}</b><button type="button" onClick={()=>changeVacationCounter('maximumGuests',1)}>+</button></Counter></CapacityItem>
  <CapacityItem><span>Dormitorios</span><small>Habitaciones privadas</small><Counter><button type="button" onClick={()=>changeCounter('dormitorios',-1)}>−</button><b>{features.dormitorios}</b><button type="button" onClick={()=>changeCounter('dormitorios',1)}>+</button></Counter></CapacityItem>
  <CapacityItem><span>Baños</span><small>Baños completos</small><Counter><button type="button" onClick={()=>changeCounter('banos',-1)}>−</button><b>{features.banos}</b><button type="button" onClick={()=>changeCounter('banos',1)}>+</button></Counter></CapacityItem>
</CapacityGrid>
<BedSection>
  <BedHeader><div><span>DISTRIBUCIÓN PARA DORMIR</span><h3>¿Qué camas hay disponibles?</h3></div><BedSummary $valid={sleepingPlaces>=Number(vacation.maximumGuests)}><strong>{sleepingPlaces}</strong><small>plazas para {vacation.maximumGuests} huéspedes</small></BedSummary></BedHeader>
  <BedGrid>{BED_TYPES.map(item=><BedRow key={item.key}><div><strong>{item.label}</strong><small>{item.places} {item.places===1?'persona':'personas'} por cama</small></div><Counter><button type="button" onClick={()=>changeBedType(item.key,-1)}>−</button><b>{vacation.bedTypes?.[item.key]||0}</b><button type="button" onClick={()=>changeBedType(item.key,1)}>+</button></Counter></BedRow>)}</BedGrid>
  {sleepingPlaces<Number(vacation.maximumGuests)&&<CapacityWarning>Agregá camas hasta cubrir una plaza por cada huésped.</CapacityWarning>}
  {capacityError&&<CapacityError role="alert">{capacityError}</CapacityError>}
</BedSection>
<Row><InputBox><label>Mínimo de noches</label><input type="number" min="1" value={vacation.minimumNights} onChange={e=>updateVacation('minimumNights',e.target.value)}/></InputBox><InputBox><label>Política de cancelación informada</label><select value={vacation.cancellationPolicy} onChange={e=>updateVacation('cancellationPolicy',e.target.value)}><option value="flexible">Flexible</option><option value="moderada">Moderada</option><option value="estricta">Estricta</option></select></InputBox></Row>
<Row><InputBox><label>Check-in desde</label><input type="time" value={vacation.checkIn} onChange={e=>updateVacation('checkIn',e.target.value)}/></InputBox><InputBox><label>Check-out hasta</label><input type="time" value={vacation.checkOut} onChange={e=>updateVacation('checkOut',e.target.value)}/></InputBox></Row>
<Helper>Bloqueá todos los períodos ya reservados o en los que no quieras recibir huéspedes.</Helper>
<Row><InputBox><label>No disponible desde</label><input type="date" value={vacation.blockedFrom} onChange={e=>updateVacation('blockedFrom',e.target.value)}/></InputBox><InputBox><label>No disponible hasta</label><input type="date" min={vacation.blockedFrom || undefined} value={vacation.blockedTo} onChange={e=>updateVacation('blockedTo',e.target.value)}/></InputBox></Row>
<BlockActions><button type="button" disabled={!vacation.blockedFrom||!vacation.blockedTo||vacation.blockedTo<=vacation.blockedFrom} onClick={addUnavailableRange}>Agregar período bloqueado</button></BlockActions>
{vacation.unavailableRanges.length>0&&<BlockedList>{vacation.unavailableRanges.map((range,index)=><li key={`${range.from}-${range.to}-${index}`}><span>{new Date(`${range.from}T12:00:00`).toLocaleDateString('es-AR')} — {new Date(`${range.to}T12:00:00`).toLocaleDateString('es-AR')}</span><button type="button" onClick={()=>removeUnavailableRange(index)}>Quitar</button></li>)}</BlockedList>}
</VacationCard>}

{isVacation && <>
<Card delay="40ms"><CardTitle>Lo que hace cómoda la estadía</CardTitle><Helper>Elegí los servicios que el huésped tendrá incluidos.</Helper><Grid>{VACATION_OPTIONS.services.map(item=><Chip key={item.key} active={vacation.services.includes(item.key)} onClick={()=>toggleVacation('services',item.key)}>{item.label}</Chip>)}</Grid></Card>
<Card delay="80ms"><CardTitle>¿Qué experiencia ofrece?</CardTitle><Helper>Esto nos ayuda a mostrarla a viajeros con la intención correcta.</Helper><Grid>{VACATION_OPTIONS.experiences.map(item=><Chip key={item.key} active={vacation.experiences.includes(item.key)} onClick={()=>toggleVacation('experiences',item.key)}>{item.label}</Chip>)}</Grid></Card>
<Card delay="120ms"><CardTitle>Para descubrir cerca</CardTitle><Helper>Marcá los atractivos del entorno. Después podés sumar distancias o recomendaciones.</Helper><Grid>{VACATION_OPTIONS.nearby.map(item=><Chip key={item.key} active={vacation.nearby.includes(item.key)} onClick={()=>toggleVacation('nearby',item.key)}>{item.label}</Chip>)}</Grid><TextArea placeholder="Ej. A 10 minutos de bodegas, frente al inicio del sendero…" value={vacation.nearbyNotes} onChange={e=>updateVacation('nearbyNotes',e.target.value)}/></Card>
</>}

{isRental && <RentalCard>
<VacationIntro><span>CONDICIONES DEL ALQUILER</span><h2>Un acuerdo claro empieza acá</h2><p>La persona interesada podrá saber si la propuesta encaja antes de consultar.</p></VacationIntro>
<Row><InputBox><label>Duración mínima del contrato</label><select value={rental.contractMonths} onChange={e=>updateRental('contractMonths',e.target.value)}><option value="6">6 meses</option><option value="12">12 meses</option><option value="24">24 meses</option><option value="36">36 meses</option></select></InputBox><InputBox><label>Meses de depósito</label><input type="number" min="0" max="6" value={rental.depositMonths} onChange={e=>updateRental('depositMonths',e.target.value)}/></InputBox></Row>
<Checkbox><input type="checkbox" checked={rental.furnished} onChange={e=>updateRental('furnished',e.target.checked)}/><span>Se entrega amoblada</span></Checkbox>
</RentalCard>}

{!isVacation && <Card delay="0ms">

<CardTitle>Información de la propiedad</CardTitle>

<FeatureHeading>Superficie</FeatureHeading>

<Row>

<InputBox>
<label>Metros cubiertos</label>
<input
type="number"
value={features.metrosCubiertos}
onChange={e=>updateField('metrosCubiertos',e.target.value)}
/>
</InputBox>

<InputBox>
<label>Metros totales</label>
<input
type="number"
value={features.metrosTotales}
onChange={e=>updateField('metrosTotales',e.target.value)}
/>
</InputBox>

</Row>

{!isLand && <><FeatureHeading>Ambientes</FeatureHeading>

<Counters>

<CounterBox>

<span>Dormitorios</span>

<Counter>

<button type="button" onClick={()=>changeCounter('dormitorios',-1)}>−</button>

<b>{features.dormitorios}</b>

<button type="button" onClick={()=>changeCounter('dormitorios',1)}>+</button>

</Counter>

</CounterBox>

<CounterBox>

<span>Baños</span>

<Counter>

<button type="button" onClick={()=>changeCounter('banos',-1)}>−</button>

<b>{features.banos}</b>

<button type="button" onClick={()=>changeCounter('banos',1)}>+</button>

</Counter>

</CounterBox>

</Counters>

<Grid>

{GROUPS[0].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.ambientes || VISIBLE_FEATURES[initialData.operation].ambientes.includes(item.key)).map(item=>{

const active=features.ambientes.includes(item.key)

return(

<Chip
key={item.key}
active={active}
onClick={()=>toggleFeature('ambientes',item.key)}
>

{item.label}

</Chip>

)

})}

</Grid>

 </>}

<FeatureHeading>Exteriores</FeatureHeading>

<Grid>

{GROUPS[1].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.exteriores || VISIBLE_FEATURES[initialData.operation].exteriores.includes(item.key)).map(item=>{

const active=features.exteriores.includes(item.key)

return(

<Chip
key={item.key} active={active} onClick={()=>toggleFeature('exteriores',item.key)}
>

{item.label}

</Chip>

)

})}

</Grid>

</Card>}

{!isVacation && <Card delay="80ms">

<CardTitle>Comodidades y extras destacados</CardTitle>

<FeatureHeading>Comodidades</FeatureHeading>
<Grid>{GROUPS[2].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.comodidades || VISIBLE_FEATURES[initialData.operation].comodidades.includes(item.key)).map(item=><Chip key={item.key} active={features.comodidades.includes(item.key)} onClick={()=>toggleFeature('comodidades',item.key)}>{item.label}</Chip>)}</Grid>

<FeatureHeading>Extras destacados</FeatureHeading>
<Grid>{GROUPS[3].items.filter(item=>!VISIBLE_FEATURES[initialData.operation]?.extras || VISIBLE_FEATURES[initialData.operation].extras.includes(item.key)).map(item=><Chip key={item.key} active={features.extras.includes(item.key)} onClick={()=>toggleFeature('extras',item.key)}>{item.label}</Chip>)}</Grid>

{isSale && <><FeatureHeading>Información adicional</FeatureHeading>

<Row>

<InputBox>
<label>Expensas</label>
<input
type="number"
value={extra.expenses}
onChange={e=>updateExtra('expenses',e.target.value)}
/>
</InputBox>

<InputBox>
<label>Antigüedad (años)</label>
<input
type="number"
value={extra.age}
onChange={e=>updateExtra('age',e.target.value)}
/>
</InputBox>

</Row>

<Row>

<InputBox>

<label>Orientación</label>

<select
value={extra.orientation}
onChange={e=>updateExtra('orientation',e.target.value)}
>

<option value="">Seleccionar</option>
<option value="norte">Norte</option>
<option value="sur">Sur</option>
<option value="este">Este</option>
<option value="oeste">Oeste</option>

</select>

</InputBox>

<InputBox>

<label>Condición</label>

<select
value={extra.condition}
onChange={e=>updateExtra('condition',e.target.value)}
>

<option value="">Seleccionar</option>
<option value="nuevo">Nuevo</option>
<option value="excelente">Excelente</option>
<option value="muy_bueno">Muy bueno</option>
<option value="bueno">Bueno</option>
<option value="a_reciclar">A reciclar</option>

</select>

</InputBox>

</Row>

<Checkbox>

<input
type="checkbox"
checked={extra.isAptoCredito}
onChange={e=>updateExtra('isAptoCredito',e.target.checked)}
/>

<span>Apto crédito hipotecario</span>

</Checkbox>

</>}

</Card>}

{isRental && <>
<Card delay="400ms"><CardTitle>Garantías aceptadas</CardTitle><Helper>Seleccioná una o varias alternativas.</Helper><Grid>{RENTAL_OPTIONS.guarantees.map(item=><Chip key={item.key} active={rental.guarantees.includes(item.key)} onClick={()=>toggleRental('guarantees',item.key)}>{item.label}</Chip>)}</Grid>{rental.guarantees.includes('garante')&&<InputBox><label>¿Cuántos garantes pedís?</label><input type="number" min="1" max="6" value={rental.guarantorsCount} onChange={e=>updateRental('guarantorsCount',e.target.value)}/></InputBox>}</Card>
<Card delay="440ms"><CardTitle>Gastos y servicios</CardTitle><Row><InputBox><label>Expensas mensuales</label><input type="number" value={extra.expenses} onChange={e=>updateExtra('expenses',e.target.value)}/></InputBox></Row><Helper>¿Qué está incluido en el valor publicado?</Helper><Grid>{RENTAL_OPTIONS.included.map(item=><Chip key={item.key} active={rental.includedServices.includes(item.key)} onClick={()=>toggleRental('includedServices',item.key)}>{item.label}</Chip>)}</Grid><TextArea placeholder="Otros requisitos o condiciones importantes…" value={rental.requirements} onChange={e=>updateRental('requirements',e.target.value)}/></Card>
</>}

{isVacation && <Card delay="400ms"><CardTitle>Reglas de la casa</CardTitle><Helper>Contá lo esencial con un tono amable: horarios de silencio, eventos, mascotas o cualquier cuidado especial.</Helper><TextArea placeholder="Ej. No se permiten fiestas. Se aceptan mascotas pequeñas con aviso previo…" value={vacation.houseRules} onChange={e=>updateVacation('houseRules',e.target.value)}/></Card>}

<Actions>

<Secondary type="button" onClick={onBack}>
Atrás
</Secondary>

<Primary type="button" onClick={handleSubmit}>
Continuar
</Primary>

</Actions>

</Container>

</Page>

)
}

/* ANIMACIÓN */

const fadeInUp = keyframes`
0%{
opacity:0;
transform:translateY(20px);
}
100%{
opacity:1;
transform:translateY(0);
}
`

/* STYLES */

const MobileQuizPage=styled.section`min-height:calc(100dvh - 122px);padding:14px 16px 92px;background:#f7f5ef;color:#29474f;@media(max-width:900px){display:flex;align-items:flex-start;}`;
const MobileQuizCard=styled.main`position:sticky;top:12px;display:flex;width:100%;max-width:520px;max-height:calc(100dvh - 218px);margin:0 auto;flex-direction:column;padding:24px 20px 28px;overflow-y:auto;border:1px solid #e5e3de;border-radius:22px;background:#fff;box-shadow:0 12px 32px rgba(41,71,79,.055);scrollbar-width:thin;h1{max-width:390px;margin:8px 0 10px;font-size:clamp(1.9rem,8vw,2.4rem);line-height:1;letter-spacing:-.055em}p{margin:0;color:#68797c;font-size:.93rem;line-height:1.5}h3{margin:27px 0 10px;color:#29474f;font-size:.82rem;font-weight:850;letter-spacing:.08em;text-transform:uppercase}`;
const MobileQuizKicker=styled.span`color:#b45f40;font-size:.68rem;font-weight:900;letter-spacing:.16em;`;
const MobileQuizClose=styled.button`position:sticky;top:0;z-index:5;display:grid;width:36px;height:36px;flex:0 0 auto;place-items:center;align-self:flex-end;margin:-12px 0 2px auto;border:1px solid #d9e1de;border-radius:50%;color:#51696e;background:#fff;font:inherit;font-size:26px;font-weight:400;line-height:1;box-shadow:0 5px 14px rgba(41,71,79,.1);cursor:pointer;`;
const ExitBackdrop=styled.div`position:fixed;z-index:1300;inset:0;display:grid;place-items:center;padding:22px;background:rgba(23,43,48,.42);backdrop-filter:blur(7px);`;
const ExitDialog=styled.section`width:min(100%,390px);padding:26px 24px;border-radius:22px;background:#fff;color:#29474f;box-shadow:0 24px 70px rgba(20,35,39,.28);>span{color:#b45f40;font-size:11px;font-weight:850;letter-spacing:.15em;}h2{margin:9px 0 9px;font-size:25px;line-height:1.05;letter-spacing:-.035em;}p{margin:0;color:#68797c;font-size:14px;line-height:1.5;}div{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:22px;}button{min-height:47px;border-radius:13px;font:inherit;font-size:13px;font-weight:800;cursor:pointer;}button:first-child{border:1px solid #d5dfdc;background:#fff;color:#51696e;}button:last-child{border:0;background:#c66f4e;color:#fff;}`;
const MobileCounterList=styled.div`display:grid;gap:10px;margin-top:28px;`;
const MobileCounterItem=styled.div`display:flex;align-items:center;justify-content:space-between;padding:16px;border:1px solid #e6d9d1;border-radius:16px;background:linear-gradient(135deg,#fff 0%,#fff7f2 100%);span{display:flex;align-items:center;gap:10px;font-weight:780;font-size:1rem}span svg{width:20px;height:20px;color:#c66f4e;stroke-width:2}`;
const MobileCapacityNote=styled.p`margin:12px 0 0!important;padding:10px 12px;border-radius:12px;background:#edf5ef;color:#426552!important;font-size:.8rem!important;font-weight:750;`;
const MobileQuizFields=styled.div`display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:23px;padding:13px;border:1px solid #ebe7e1;border-radius:17px;background:#faf9f6;>div{gap:6px}>div label{font-size:.74rem;font-weight:760}>div input,>div select{height:48px;padding:0 12px;border-color:#dddeda;background:#fff}`;
const MobileQuizChips=styled.div`display:flex;flex-wrap:wrap;gap:8px;margin-top:10px;button{min-height:42px;padding:0 13px;font-size:.88rem}`;
const RulesExamples=styled.div`margin:22px 0 0;padding:13px 14px;border-radius:14px;background:#fff3ec;border:1px solid #f1d9cc;color:#8d4b35;font-size:.82rem;line-height:1.5;font-weight:650;`;
const RulesOptional=styled.p`margin:10px 0 0!important;color:#758589!important;font-size:.78rem!important;`;
const ContactOptions=styled.div`display:none;`;
const MobileQuizFooter=styled.div`position:fixed;z-index:1100;right:0;bottom:0;left:0;display:grid;grid-template-columns:1fr 1.45fr;gap:10px;padding:13px 16px calc(13px + env(safe-area-inset-bottom));border-top:1px solid rgba(41,71,79,.1);background:rgba(255,253,249,.96);backdrop-filter:blur(14px);button{min-height:52px;border-radius:15px;font:inherit;font-size:.92rem;font-weight:850;cursor:pointer}button:first-child{border:1px solid #d5dfdc;background:#fff;color:#51696e}button:last-child{border:0;background:#c66f4e;color:#fff;box-shadow:0 9px 20px rgba(198,111,78,.2)}`;

const Page=styled.div`
padding:60px 20px;
background:#f7f5ef;
min-height:100vh;
min-width:0;
overflow-x:hidden;
@media(max-width:600px){padding:48px 16px 76px;}
`

const Container=styled.div`
max-width:900px;
margin:auto;
`

const Header=styled.div`
margin-bottom:40px;

h1{
font-size:clamp(38px,5vw,56px);color:#29474f;letter-spacing:-.045em;
margin-bottom:6px;
overflow-wrap:anywhere;
}

p{
color:#666;
font-size:16px;
}
`

const Card=styled.div`
background:rgba(255,255,255,.82);border:1px solid rgba(41,71,79,.1);
padding:32px;
border-radius:24px;
box-shadow:0 12px 40px rgba(0,0,0,0.06);
margin-bottom:30px;

animation:${fadeInUp} .45s ease both;
animation-delay:${props=>props.delay || "0ms"};

transition:all .25s ease;

&:hover{
transform:translateY(-2px);
box-shadow:0 18px 55px rgba(0,0,0,0.08);
}
@media(max-width:600px){padding:22px 16px;border-radius:20px;margin-bottom:18px;}
`

const CardTitle=styled.h3`
font-size:23px;
font-weight:600;
margin-bottom:22px;
color:#222;
`
const FeatureHeading=styled.h4`margin:26px 0 14px;padding-top:22px;border-top:1px solid rgba(41,71,79,.1);color:#52686d;font-size:14px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;&:first-of-type{margin-top:0;padding-top:0;border-top:0;}`;
const Helper=styled.p`margin:-12px 0 20px;color:#657679;font-size:16px;line-height:1.6;`;
const TextArea=styled.textarea`width:100%;min-height:110px;box-sizing:border-box;margin-top:22px;padding:16px 18px;border:1px solid rgba(41,71,79,.15);border-radius:16px;background:#fff;color:#29474f;font:inherit;line-height:1.5;resize:vertical;&:focus{outline:none;border-color:#c66f4e;box-shadow:0 0 0 3px rgba(198,111,78,.12);}`;
const BlockActions=styled.div`
display:flex;justify-content:flex-end;margin:-8px 0 18px;
button{min-height:42px;padding:0 17px;color:#fff;background:#29474f;border:0;border-radius:999px;font:inherit;font-size:14px;font-weight:680;cursor:pointer}
button:disabled{opacity:.4;cursor:not-allowed}
`;
const BlockedList=styled.ul`
display:grid;gap:8px;margin:0;padding:0;list-style:none;
li{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:12px 14px;color:#29474f;background:#f4f1ea;border:1px solid rgba(41,71,79,.1);border-radius:12px;font-size:14px}
button{padding:4px;color:#b45f40;background:transparent;border:0;font:inherit;font-size:12px;font-weight:680;cursor:pointer}
@media(max-width:520px){li{align-items:flex-start;flex-direction:column;}button{align-self:flex-end;}}
`;

const Row=styled.div`
display:flex;
gap:22px;
flex-wrap:wrap;
margin-bottom:22px;
@media(max-width:560px){display:grid;grid-template-columns:minmax(0,1fr);gap:14px;}
`

const InputBox=styled.div`
flex:1;
min-width:0;
display:flex;
flex-direction:column;
gap:8px;

label{
font-size:16px;
font-weight:500;
color:#444;
}

input,
select{
width:100%;
min-width:0;
box-sizing:border-box;
height:46px;
padding:0 16px;
border-radius:12px;
border:1px solid #dcdcdc;
font-size:16px;
background:white;
color:#29474f;
font-family:inherit;

appearance:none;

background-image:url("data:image/svg+xml;utf8,<svg fill='%23999' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M5.5 7l4.5 5 4.5-5z'/></svg>");
background-repeat:no-repeat;
background-position:right 14px center;

transition:all .15s ease;
}

input:focus,
select:focus{
outline:none;
border-color:#c66f4e;
box-shadow:0 0 0 3px rgba(242,122,26,0.15);
}
`

const Counters=styled.div`
display:flex;
gap:40px;
margin-bottom:20px;
@media(max-width:400px){justify-content:space-between;gap:16px;}
`

const CapacityGrid=styled.div`
display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin:0 0 24px;
@media(max-width:720px){grid-template-columns:1fr 1fr}
@media(max-width:480px){grid-template-columns:1fr}
`;

const BedSection=styled.div`min-width:0;margin:0 0 24px;padding:18px;color:#29474f;background:#f6f3ed;border-radius:18px;@media(max-width:480px){padding:14px 10px;}`;
const BedHeader=styled.div`display:flex;align-items:center;justify-content:space-between;gap:20px;margin-bottom:15px;span{color:#b45f40;font-size:12px;font-weight:800;letter-spacing:.14em}h3{margin:4px 0 0;font-size:20px;letter-spacing:-.025em}@media(max-width:560px){align-items:flex-start;flex-direction:column;}`;
const BedSummary=styled.div`min-width:130px;padding:10px 13px;color:${({$valid})=>$valid?'#315c49':'#9d4d35'};background:${({$valid})=>$valid?'#e5f2e9':'#fff0ea'};border-radius:12px;text-align:center;strong,small{display:block}strong{font-size:24px}small{margin-top:2px;font-size:12px;}`;
const BedGrid=styled.div`display:grid;grid-template-columns:1fr 1fr;gap:8px;@media(max-width:650px){grid-template-columns:1fr}`;
const BedRow=styled.div`min-width:0;display:flex;align-items:center;justify-content:space-between;gap:8px;padding:12px 10px;background:#fff;border:1px solid rgba(41,71,79,.1);border-radius:13px;strong,small{display:block}strong{font-size:13px}small{margin-top:3px;color:#7d898b;font-size:12px}>div:first-child{min-width:0}>div:last-child{margin-left:auto;flex:0 0 auto}`;
const CapacityWarning=styled.p`margin:13px 0 0!important;color:#9d4d35!important;font-size:12px!important;font-weight:650;`;
const CapacityError=styled.div`margin-top:12px;padding:11px 13px;color:#8f3526;background:#ffe9e2;border-radius:11px;font-size:12px;font-weight:700;`;

const CapacityItem=styled.div`
display:flex;min-width:0;flex-direction:column;padding:16px;color:#29474f;background:#fff;border-radius:16px;
>span{font-size:15px;font-weight:720}>small{min-height:30px;margin:4px 0 13px;color:#78878a;font-size:12px;line-height:1.35}
>div{justify-content:space-between}>div button{border-color:rgba(41,71,79,.15);font-size:18px}>div b{min-width:22px;text-align:center}
`;

const CounterBox=styled.div`
display:flex;
flex-direction:column;
gap:6px;
`

const Counter=styled.div`
display:flex;
align-items:center;
gap:10px;

button{
width:34px;
height:34px;
border-radius:10px;
border:1px solid #ddd;
background:white;
cursor:pointer;
}

b{
font-size:18px;
}
`

const Grid=styled.div`
display:flex;
flex-wrap:wrap;
gap:10px;
min-width:0;
`

const Chip=styled.div`
padding:9px 16px;
border-radius:999px;
cursor:pointer;
font-size:16px;
border:1px solid #e2e2e2;
background:${p=>p.active?'#c66f4e':'white'};
color:${p=>p.active?'white':'#444'};
transition:all .2s;

&:hover{
transform:scale(1.05);
}
`

const Checkbox=styled.label`
display:flex;
align-items:center;
gap:12px;
margin-top:16px;
font-size:16px;
color:#444;

input{
width:18px;
height:18px;
accent-color:#c66f4e;
cursor:pointer;
}
`

const Actions=styled.div`
display:flex;
justify-content:space-between;
margin-top:40px;
gap:14px;
@media(max-width:520px){align-items:stretch;flex-direction:column-reverse;button{width:100%;}}
`

const Primary = styled.button`
background: linear-gradient(135deg, #C66F4E 0%, #ff9d5a 100%);
color: white;
padding: 16px 44px;
border-radius: 999px;
border: none;
font-weight: 600;
font-size: 17px;
cursor: pointer;
box-shadow: 0 12px 28px rgba(198,111,78,0.35);

&:hover{
transform:translateY(-2px);
box-shadow:0 18px 38px rgba(198,111,78,0.45);
}
`

const Secondary=styled.button`
background:none;
border:none;
font-size:17px;
color:#777;
cursor:pointer;
`
const VacationCard=styled(Card)`background:#29474f;color:white;border:0;label{color:#edf3f1;}input,select{background:#fff;}h2{font-size:30px;margin:7px 0 6px;letter-spacing:-.035em;overflow-wrap:anywhere;}p{color:#cbd8d6;margin:0 0 24px;}@media(max-width:480px){h2{font-size:26px;}}`;
const RentalCard=styled(VacationCard)`background:#fff;color:#29474f;border:1px solid rgba(198,111,78,.28);label{color:#29474f;}p{color:#68777b;}`;
const VacationIntro=styled.div`span{font-size:12px;font-weight:800;letter-spacing:.15em;color:#f0ad8f;}`;
